import { render } from "./Navbar.vue?vue&type=template&id=9895fde6&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=9895fde6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9895fde6"]])

export default __exports__